import aqilaApi from './aqila-api';

class AqilaRecomendacoes {
  private readonly endpoint = '/v1/aqila_recomendacoes';

  async aprovar(id: number) {
    await aqilaApi.patch(`${this.endpoint}/${id}/aprovar`);
  }

  async rejeitar(id: number, motivo?: string) {
    await aqilaApi.patch(`${this.endpoint}/${id}/rejeitar`, {
      motivo_rejeicao: motivo,
    });
  }
}

export default new AqilaRecomendacoes();
